import { fetchPositionDashBoard } from '@/api/business/unsettledSecurities'
import { useQuery } from '@tanstack/react-query'

export const PositionDashBoardKeys = {
    all: ['positiondashboard'] as const,
    lists: () => [...PositionDashBoardKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...PositionDashBoardKeys.lists(), page, perPage, filters] as const,
    details: () => [...PositionDashBoardKeys.all, 'detail'] as const,
    detail: (params: string) => [...PositionDashBoardKeys.details(), params] as const,
}

export const usePositionDashBoardQuery = () => {
    return useQuery({
        queryFn: fetchPositionDashBoard,
        queryKey: PositionDashBoardKeys.lists(),
    })
}
